export default __webpack_public_path__ + "static/media/birkholz.e0388784.jpg";